<div class="p-5">
  <h4 class="text-center">{{ 'MODAL_REDIRECT_SDA.TITLE' | translate }}</h4>
  <h5 class="text-center">{{ 'MODAL_REDIRECT_SDA.SUBTITLE' | translate }}</h5>
  <h5 class="text-center">{{ 'MODAL_REDIRECT_SDA.SUBTITLE_2' | translate }}</h5>
  <a class="see_more_button m-auto appColorBackground white" [style.backgroundColor]="eventData['mainColor']" [style.color]="eventData['languageColor']"  [href]="url" target="_blank" >{{ 'MODAL_REDIRECT_SDA.BUY_TICKET' | translate }}</a>
</div>
<div class="d-flex justify-content-end p-3">
  <button class="btn btn--submit appColorBackground white" [style.backgroundColor]="eventData['mainColor']" [style.color]="eventData['languageColor']" type="button" (click)="accept()">{{ 'MODAL_REDIRECT_SDA.ACCEPT' | translate }}</button>
</div>
